// extracted by mini-css-extract-plugin
module.exports = {"icon":"IllustrationStatic_icon__TW2cp"};